import tooltips from "@/constants/ToolTips"
import { View } from "react-native"
import Tooltip from "rn-tooltip"
import { BFColors } from "@/constants/Colors"
import InfoIcon from "@/assets/icons/tooltip-i-bold-icon.svg"
import BFText, { Tiny } from "@/components/standard/BFText"
import React from "react"

interface MarketDataTooltipProps {
  type: "medianPrice" | "daysOnMarket" | "saleToList" | "inventory"
  title: string
}

const MarketDataTitleTooltipRow: React.FC<MarketDataTooltipProps> = ({
  type,
  title,
}) => {
  const tooltipText = (() => {
    switch (type) {
      case "medianPrice":
        return tooltips.marketMedianPrice
      case "daysOnMarket":
        return tooltips.marketMedianDOM
      case "saleToList":
        return tooltips.marketSaleToList
      case "inventory":
        return tooltips.marketInventory
      default:
        return "No information available"
    }
  })()

  return (
    <View className="flex-row">
      <Tiny className="text-white mr-[2px]">{title}</Tiny>
      <Tooltip
        popover={
          <BFText className="font-spacegrotesk text-midnight-blue text-[12px] p-[2px]">
            {tooltipText}
          </BFText>
        }
        actionType="press"
        backgroundColor={BFColors.lightGrey}
        withOverlay={false}
        height={"auto"}
        width={192}
        containerStyle={{ borderRadius: 2 }}
        toggleWrapperProps={{ hitSlop: 12 }}
      >
        <View>
          <InfoIcon width={11} height={11} />
        </View>
      </Tooltip>
    </View>
  )
}

export default MarketDataTitleTooltipRow
